<template>
  <v-flex>
    <v-card>
      <v-card-title primary-title>
        <h2>New Chart</h2>
      </v-card-title>
      <v-card-text>
        <v-form id="funnel-form" v-model="valid" ref="form">
          <v-layout>
            <v-flex>
              <v-menu
                :ref="'startDate'"
                :close-on-content-click="true"
                v-model="startMenu"
                lazy
                transition="scale-transition"
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="startDate"
                  label="Start Date"
                  append-icon="event"
                  readonly
                  :rules="[() => !!startDate || 'Start Date required']"
                  required
                ></v-text-field>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  :show-current="false"
                  scrollable
                  required
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-menu
                :ref="'endDate'"
                :close-on-content-click="true"
                v-model="endMenu"
                lazy
                transition="scale-transition"
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="endDate"
                  label="End Date"
                  append-icon="event"
                  readonly
                  :rules="[() => !!endDate || 'End Date required']"
                  required
                ></v-text-field>
                <v-date-picker
                  v-model="endDate"
                  no-title
                  :show-current="false"
                  scrollable
                  required
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-select
                v-model="ownerId"
                :items="owners"
                label="Lead Owner"
                item-text="name"
                item-value="id"
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-select
                v-model="opportunityType"
                :items="opportunityTypeOptions"
                label="Lead Type"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="addChart"
          :disabled="!valid"
          color="success"
          >
          Create
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'NewFunnelForm',

  data() {
    return {
      startDate: null,
      endDate: null,
      ownerId: null,
      opportunityType: null,
      startMenu: false,
      endMenu: false,
      valid: false,
      opportunityTypeOptions: [
        {
          value: 'consumer',
          text: 'Consumer'
        },
        {
          value: 'business',
          text: 'Business'
        },
        {
          value: null,
          text: 'All'
        }
      ]
    };
  },

  computed: {
    ...mapState('leadOwners', ['owners'])
  },

  methods: {
    addChart() {
      if (this.$refs.form.validate()) {
        const chartData = {
          startDate: this.startDate,
          endDate: this.endDate,
          ownerId: this.ownerId,
          opportunityType: this.opportunityType
        };
        this.$emit('newChart', chartData);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .card__text {
    padding-bottom: 2px;
    .layout .flex {
      padding: 0px 8px;
    }
  }

  .card__actions {
    padding-bottom: 16px;
    padding-left: 11px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reports/leads/NewFunnelForm.vue